import type { ComponentType } from "react"

import { EventModal } from "../components/event-modal"
import { Free3MinutesGiftModal } from "../components/free-3-minutes-gift-modal"
import { ReportAstrologyModalV1 } from "../components/report-astrology-modal-v1"
import { ReportAstrologyModalV2 } from "../components/report-astrology-modal-v2"
import { ReportAstroMapModalV1 } from "../components/report-astro-map-modal-v1"
import { ReportAstroMapModalV2 } from "../components/report-astro-map-modal-v2"
import { ReportLoveMatchModalV1 } from "../components/report-love-match-modal-v1"
import { ReportLoveMatchModalV2 } from "../components/report-love-match-modal-v2"
import { ReportSoulmateSketchModalV1 } from "../components/report-soulmate-sketch-modal-v1"
import { ReportSoulmateSketchModalV2 } from "../components/report-soulmate-sketch-modal-v2"
import { ReportAuraScanModalV1 } from "../components/report-aura-scan-modal-v1"
import { ReportAuraScanModalV2 } from "../components/report-aura-scan-modal-v2"
import { ReviewModal } from "../components/review-modal"
import { StarsSpecialOfferV1Modal } from "../components/stars-special-offer-v1-modal"
import { StarsSpecialOfferV2Modal } from "../components/stars-special-offer-v2-modal"
import type { AppModalType } from "../types"

export interface AppModalComponentProps {
  type: AppModalType
  onClose: () => void
}

type ModalEntry = {
  Component: ComponentType<AppModalComponentProps>
}

export const modalRegistry = {
  review: { Component: ReviewModal },
  free_3_minutes_gift: { Component: Free3MinutesGiftModal },
  event: { Component: EventModal },
  stars_special_offer_v1: { Component: StarsSpecialOfferV1Modal },
  stars_special_offer_v2: { Component: StarsSpecialOfferV2Modal },
  report_astrology_v1: { Component: ReportAstrologyModalV1 },
  report_love_match_v1: { Component: ReportLoveMatchModalV1 },
  report_astro_map_v1: { Component: ReportAstroMapModalV1 },
  report_soulmate_sketch_v1: { Component: ReportSoulmateSketchModalV1 },
  report_aura_scan_v1: { Component: ReportAuraScanModalV1 },
  report_astrology_v2: { Component: ReportAstrologyModalV2 },
  report_love_match_v2: { Component: ReportLoveMatchModalV2 },
  report_astro_map_v2: { Component: ReportAstroMapModalV2 },
  report_soulmate_sketch_v2: { Component: ReportSoulmateSketchModalV2 },
  report_aura_scan_v2: { Component: ReportAuraScanModalV2 },
} as const satisfies Record<AppModalType, ModalEntry>

export function getModalEntry(type: AppModalType): ModalEntry {
  return modalRegistry[type]
}
